import { isCapacitorNative } from 'Utils/Constants';
import ITimeKeeper from './ITimeKeeper';
import TimeKeeper from './TimeKeeper';
import NativeTimeKeeper from './NativeTimeKeeper';

export function createTimeKeeper(): ITimeKeeper {
  if (isCapacitorNative()) {
    return new NativeTimeKeeper();
  }
  return new TimeKeeper();
}

export function isNativeTimeKeeper(tk: ITimeKeeper): tk is NativeTimeKeeper {
  return tk instanceof NativeTimeKeeper;
}
